export default {
    opacity: {
        type: Boolean,
        default: undefined
    }, 
    buttons: {
        type: Boolean,
        default: undefined
    }, 
    value: {
        type: String,
        default: undefined
    }, 
    preview: {
        type: Boolean,
        default: undefined
    }, 
    autoupdate: {
        type: Boolean,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/FlatColorPickerProps.js